import { API_BASE_URL } from '../constant/api-url';

// Baked in at build time by src/write-env.js (--appinsights=, --environment=, --build=). CRA
// inlines each literal `process.env.REACT_APP_*` reference, so they stay spelled out here.
export const connectionString =
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING || '';
export const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
export const appVersion = process.env.REACT_APP_VERSION || '';
export const apiBaseUrl = API_BASE_URL;

const hostOf = (url: string): string => {
  try {
    return new URL(url).host;
  } catch {
    return '';
  }
};

// Only API calls get `traceparent` and the session header; Auth0 and the rest never see them.
export const apiHost = hostOf(API_BASE_URL);

// The SDK refuses `|` in authenticated user ids; the API and the dashboard do the same replace.
export const toTelemetryUserId = (sub: string): string =>
  sub.replace(/\|/g, ':');
